import React from 'react';

import { Form, Formik } from 'formik';

import Button from '@material-ui/core/Button';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { MdDelete } from 'react-icons/md';

import Paper from '@material-ui/core/Paper';

import TextField from '@material-ui/core/TextField';

import InputLabel from '@material-ui/core/InputLabel';

import MenuItem from '@material-ui/core/MenuItem';

import SelectMUI from '@material-ui/core/Select';

import { ListStyled, ListItem } from '../../css/Styles/list-grid';

import SelectStyled from '../../styles/select';

import ReactSelect from 'react-select';
import color from '@material-ui/core/colors/amber';

const styles = theme => ({
  root: {
    width: '90%',

    marginTop: theme.spacing.unit * 3,

    paddingBottom: theme.spacing.unit * 3,

    overflowX: 'auto',
  },

  container: {
    display: 'flex',

    flexWrap: 'wrap',
  },

  textField: {
    margin: theme.spacing.unit * 0.5,

    marginBottom: theme.spacing.unit * 3,

    width: '45%',

    textAlign: 'center',
  },

  textFieldNumber: {
    margin: theme.spacing.unit * 0.5,

    width: '40%',

    textAlign: 'center',
  },

  rootSelect: {
    display: 'flex',

    flexWrap: 'wrap',

    width: '90%',
  },

  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

const handleValidate = ({ quantity, pieceUuid }) => {
  const errors = {};

  if (!quantity || quantity === 0) errors.quantity = 'OBRIGATÓRIO';

  if (!pieceUuid) errors.pieceUuid = 'OBRIGATÓRIO';

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  await props.onAdd({ ...values });

  setSubmitting(false);
  resetForm();
};

const optionTotal = option => {
  const totalStr = option.label.split('||')[1].trim();
  return parseInt(totalStr, 10) || 0;
};

const MovementForm = props => {
  const {
    classes,

    pieces,

    piece,

    movements,

    onDelete,
  } = props;
  const pieceOptions = pieces
    ? pieces.map(piece => ({
        value: piece.uuid,
        label: `${piece.description} || ${piece.total || 0}`,
        total: piece.total || 0,
      }))
    : [];

  const [selectedPiece, setSelectedPiece] = React.useState(
    piece
      ? {
          value: piece.uuid,
          label: `${piece.description} || ${piece.total || 0}`,
        }
      : null
  );
  return (
    <div>
      <Paper className={classes.root}>
        <h1>ADICIONAR MOVIMENTAÇÃO</h1>

        <Formik
          enableReinitialize
          initialValues={{
            quantity: 0,
            pieceUuid: piece ? piece.uuid : '',
          }}
          validate={handleValidate(props)}
          onSubmit={handleSubmit(props)}
        >
          {({
            values,
            errors,
            touched,
            dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleReset,
          }) => (
            <Form>
              <div className={classes.formControl}>
                <InputLabel
                  style={{ disableAnimation: false }}
                  disableAnimation={false}
                  htmlFor="pieceUuid"
                >
                  PEÇA
                </InputLabel>

                <ReactSelect
                  id="pieceUuid"
                  name="pieceUuid"
                  value={selectedPiece}
                  onChange={e => {
                    setSelectedPiece(e);
                    handleChange({
                      target: { name: 'pieceUuid', value: e.value },
                    });
                  }}
                  onBlur={handleBlur}
                  inputProps={{
                    name: 'pieceUuid',

                    id: 'pieceUuid',
                  }}
                  options={pieceOptions}
                  getOptionLabel={option => option.label}
                  styles={{
                    ...SelectStyled,
                    option: (provided, state) => {
                      const isLow = optionTotal(state.data) <= 4;
                      return {
                        ...provided,
                        backgroundColor: isLow && '#ff0000',
                        fontWeight: isLow ? 'bold' : 'normal',
                        color: isLow ? '#fff' : '#000',
                      };
                    },
                    singleValue: (provided, state) => {
                      const isLow = optionTotal(state.data) <= 4;
                      return {
                        ...provided,
                        color: isLow ? '#ff0000' : '#000',
                        fontWeight: isLow ? 'bold' : 'normal',
                      };
                    },
                  }}
                  placeholder="Selecione a peça"
                />
              </div>

              <div>
                <TextField
                  id="quantity"
                  name="quantity"
                  label="Quantidade"
                  type="number"
                  variant="outlined"
                  value={values.quantity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={classes.textField}
                  error={!!(errors.quantity && touched.quantity)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                {errors.quantity && touched.quantity && (
                  <div style={{ color: 'red' }}>{errors.quantity}</div>
                )}
              </div>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={() => {
                  setSelectedPiece(null);
                }}
                disabled={!dirty || isSubmitting}
                style={{ margin: '10px' }}
              >
                ADICIONAR
              </Button>

              <Button
                variant="contained"
                color="primary"
                type="reset"
                onClick={handleReset}
                disabled={!dirty || isSubmitting}
                style={{ margin: '10px' }}
              >
                RESET
              </Button>
            </Form>
          )}
        </Formik>
        {movements && movements[0] && (
          <ListStyled gridHeader="4fr 2fr 2fr 0.5fr">
            <header>
              <div className="titles">
                <strong>PEÇA</strong>
                <strong>QUANTIDADE</strong>
                <strong>ATUAL</strong>
                <strong />
              </div>
            </header>
            {movements.map((movement, index) => (
              <ListItem
                gridList="4fr 2fr 2fr 0.5fr"
                color="#333"
                strongColor="#fff"
                key={`${movement.pieceUuid}-${movement.quantity}`}
              >
                <strong>{movement.piece.description}</strong>
                <strong>{movement.quantity}</strong>
                <strong>{movement.piece.total || 0}</strong>
                <button type="button" onClick={() => onDelete(index)}>
                  <MdDelete color="#ff5757" size={20} />
                </button>
              </ListItem>
            ))}
          </ListStyled>
        )}
      </Paper>
    </div>
  );
};

MovementForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MovementForm);
